// extracted by mini-css-extract-plugin
module.exports = {"nav":"NavBar_nav__d8rHC","navlink":"NavBar_navlink__16brw"};